import { HOKAGE_SERVICE_CUTOFF_AT } from "~/constants/hokageMigration";

/** 締め切り日時（ちょうど）以降なら true。now は端末時計なのでテストでは差し替える */
export const isAfterHokageServiceCutoff = (now: Date = new Date()): boolean =>
  now.getTime() >= new Date(HOKAGE_SERVICE_CUTOFF_AT).getTime();
